import { theme } from '@/components/features/theme/theme';
import styled from 'styled-components';

export const StyledGetInTouch = styled.section`
	position: relative;
	width: 100%;
	background-color: ${props => props?.color || 'white'};

	@keyframes slide-in {
		0% {
			opacity: 1;
			-webkit-transform: translateY(-100%);
			transform: translateY(-100%);
		}

		60% {
			opacity: 1;
			-webkit-transform: translateY(20%);
			transform: translateY(20%);
		}
		100% {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
	}
	@keyframes slide-out {
		0% {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		60% {
			opacity: 1;
			-webkit-transform: translateY(120%);
			transform: translateY(120%);
		}
		100% {
			opacity: 0;
			-webkit-transform: translateY(100%);
			transform: translateY(100%);
		}
	}
	.word-rotator-words {
		overflow: hidden;
		vertical-align: top;
		display: -ms-inline-flexbox !important;
		display: inline-flex !important;
		position: relative;
		text-align: left;
		height: 35px;
		@media (min-width: 1024px) {
			height: 72px;
		}
		@media (max-width: 767px) {
			height: 45px;
		}

		b {
			display: inline-block;
			position: absolute;
			white-space: nowrap;
			left: 0;
			top: 0;
			opacity: 0;
			&.is-hidden {
				-webkit-animation: slide-out 0.8s;
				animation: slide-out 0.8s;
			}
			&.is-visible {
				top: 0;
				opacity: 1;
				-webkit-animation: slide-in 0.8s;
				animation: slide-in 0.8s;
			}
		}
	}

	.wrapper-box {
		position: relative;
		border-radius: 0 4px 4px 0;
		background: #dd223f;
		padding-top: 25px;
		padding-bottom: 25px;
	}

	//transform: translateY(60px);
	//margin-top: -60px;
	&:after {
		background-color: ${props => props?.color || 'white'};
		top: 0;
		position: absolute;
		left: 0;
		right: 0;
		width: 100%;
		height: 50%;
		content: '';
		z-index: -1;
		margin-right: ${props => `-${props?.offset + 15 + 'px'}` || '0px'};
	}

	.overlay-main-bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgb(0 0 0 / 50%);
		backdrop-filter: blur(10px);
		z-index: 999999;
	}

	h2 {
		color: ${theme.colors.white};
		font-size: 2rem;
		font-style: normal;
		font-weight: 500;
		line-height: 2.25rem;
		letter-spacing: 0;

		i {
			font-weight: 400;
		}
	}

	p {
		color: ${theme.colors.white};
		font-size: 1.5rem;
		font-style: normal;
		font-weight: 500;
		line-height: 1.75rem;
		letter-spacing: 0;
	}

	.get_in_touch {
		position: relative;
		z-index: 2;

		a.icon-hover-main {
			color: #fff;
			font-size: 1rem;
			font-style: normal;
			font-weight: 500;
			line-height: 1.5rem;

			&:hover {
				color: ${theme.colors.primary} !important;

				svg {
					path {
						stroke: ${theme.colors.primary} !important;
					}
				}
			}
		}
	}

	@media (max-width: 767px) {
		margin: 0 !important;
		padding-top: 40px;
		padding-bottom: 40px;

		h2 {
			font-style: normal;
			font-weight: 500 !important;
			margin-bottom: 15px;
		}

		.d-flex.align-items-center.justify-content-end.col-md-5 {
			justify-content: flex-start !important;
			margin-top: 20px;
		}
	}
`;
